import { render, staticRenderFns } from "./infeedPage.vue?vue&type=template&id=0fa051c9&scoped=true"
import script from "./infeedPage.vue?vue&type=script&lang=js"
export * from "./infeedPage.vue?vue&type=script&lang=js"
import style0 from "./infeedPage.vue?vue&type=style&index=0&id=0fa051c9&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fa051c9",
  null
  
)

export default component.exports